import { render, staticRenderFns } from "./NotificationHistoryTimeline.vue?vue&type=template&id=1903da17&scoped=true&"
import script from "./NotificationHistoryTimeline.vue.js?vue&type=script&lang=js&"
export * from "./NotificationHistoryTimeline.vue.js?vue&type=script&lang=js&"
import style0 from "./NotificationHistoryTimeline.vue?vue&type=style&index=0&id=1903da17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903da17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VApp,VAvatar,VCard,VCardText,VImg,VPagination,VTimeline,VTimelineItem})
